import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router'

import { useNotifications } from 'app/application/application'
import { Form } from 'app/common/presentation'
import { useShopifyConnectionApi } from 'app/connections/application'
import { ShopifyConnection } from 'app/connections/types'

import { Button } from 'components'

import styles from './Setup.module.scss'

interface ShopifySettingsProps {
  connection: ShopifyConnection
}

const ShopifySettings = ({ connection }: ShopifySettingsProps) => {
  const navigate = useNavigate()
  const { t } = useTranslation('connections')

  const { createNotification, te } = useNotifications()
  const { updateShop } = useShopifyConnectionApi()

  const currentShop = connection.config.shops[0] ?? ''

  const [shop, setShop] = useState<string>(currentShop)
  const [isSaving, setIsSaving] = useState<boolean>(false)

  const handleSave = () => {
    setIsSaving(true)

    void updateShop(shop.trim())
      .then((result) => {
        if (result.ok) {
          createNotification({
            message: t('update.success.message', {
              name: t(`available.${connection.name}.displayName`),
            }),
            title: t('update.success.title'),
            type: 'success',
          })
        } else {
          createNotification({
            message: result.val.message,
            title: te(`http.${result.val.code}`),
            type: 'error',
          })
        }
      })
      .finally(() => setIsSaving(false))
  }

  return (
    <div className={styles.form}>
      <Form.InputFormRow
        description={t(`setup.${connection.name}.config.shop.description`)}
        onChange={setShop}
        placeholder={t(`setup.${connection.name}.config.shop.title`)}
        title={t(`setup.${connection.name}.config.shop.title`)}
        value={shop}
      />
      <div className={styles.actions}>
        <Button onClick={() => void navigate(-1)} variant="secondary">
          {t('setup.actions.back')}
        </Button>
        <Button
          disabled={!shop.trim() || shop.trim() === currentShop}
          loading={isSaving}
          onClick={(e) => {
            e.stopPropagation()

            handleSave()
          }}
        >
          {t('setup.actions.save')}
        </Button>
      </div>
    </div>
  )
}

export default ShopifySettings
